export default "__VITE_ASSET__V4Shfdo1__"